import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { updateAddress, getCustomer } from 'actions/paymentsManager'
import { TextField } from '@material-ui/core'
import language from 'utils/vast-languagepack'
import states from 'components/AccountSettingsPage/states'
import Select from 'react-select'
import Button from 'components/theme/Button'
import { last } from 'lodash'

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    borderBottom: '1px dotted red',
    color: 'black',
    padding: 20,
    zIndex: 2,
    opacity: 1,
    backgroundColor: 'white',
  }),
}

class Address extends Component {
  constructor(props) {
    super(props)

    this.state = {
      streetAddress: props.streetAddress || '',
      extendedAddress: props.extendedAddress || '',
      locality: props.locality || '',
      region: props.region || '',
      postalCode: props.postalCode || '',
      countryCodeAlpha2: 'US',
    }
  }

  handleStateChange = (selectedOption) => {
    this.setState({
      region: selectedOption.value,
    })
  }

  render() {
    return (
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <p>
          {this.props.numberOfAddresses > 1 ? 'Re-enter' : 'Enter'} your address
          and click <strong>set billing address</strong>.
        </p>
        {this.props.anyMissingRequiredAddressFields && (
          <p style={{ color: 'red' }}>You are missing required fields.</p>
        )}
        <TextField
          variant="outlined"
          onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
          name="streetAddress"
          label={`${language.accountSettings.labels.addressLabel}*`}
          style={{ margin: 8 }}
          value={this.state.streetAddress}
          placeholder={language.accountSettings.helperText.addressPlaceHolder}
          fullWidth
          inputProps={{
            baseproperty: 'mailing',
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          variant="outlined"
          onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
          name="extendedAddress"
          label={language.accountSettings.labels.addressLabel2}
          style={{ margin: 8 }}
          placeholder={language.accountSettings.helperText.addressPlaceHolder2}
          fullWidth
          value={this.state.extendedAddress}
          inputProps={{
            baseproperty: 'mailing',
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          variant="outlined"
          onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
          name="locality"
          fullWidth
          label={`${language.accountSettings.labels.cityLabel}*`}
          style={{ margin: 8 }}
          placeholder={language.accountSettings.helperText.cityPlaceHolder}
          value={this.state.locality}
          inputProps={{
            baseproperty: 'mailing',
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <p
          style={{
            display: 'block',
            fontSize: 10,
            margin: '8px 8px 0px 8px',
            color: '#AAAAAA',
            textAlign: 'left',
          }}
        >
          State/Region*
        </p>
        <p style={{ display: 'block', fontSize: 12, margin: 8 }}>
          <Select
            value={{
              label: this.state.region,
              value: this.state.region,
            }}
            styles={customStyles}
            placeholder={language.accountSettings.helperText.statePlaceHolder}
            onChange={this.handleStateChange}
            options={states.map((stateObj) => ({
              ...stateObj,
              value: stateObj.label,
            }))}
          />
        </p>
        <TextField
          variant="outlined"
          onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
          name="postalCode"
          label={`${language.accountSettings.labels.zipLabel}*`}
          style={{ margin: 8 }}
          placeholder={language.accountSettings.helperText.zipPlaceHolder}
          value={this.state.postalCode}
          inputProps={{
            baseproperty: 'mailing',
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          variant="outlined"
          disabled
          onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
          name="countryCodeAlpha2"
          label={`${language.accountSettings.labels.countryLabel}*`}
          style={{ margin: 8 }}
          placeholder={language.accountSettings.helperText.countryPlaceHolder}
          value={'US'}
          inputProps={{
            baseproperty: 'mailing',
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <div>
          <Button
            onClick={() =>
              this.props
                .updateAddress(this.state, this.props.addressId)
                .then(() => this.props.getCustomer())
            }
            style={{ backgroundColor: 'green', marginTop: 10, color: '#fff' }}
          >
            Set billing address for card
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => {
    if (
      state.paymentsManager &&
      state.paymentsManager.customer &&
      state.paymentsManager.customer.addresses &&
      last(state.paymentsManager.customer.addresses)
    ) {
      return {
        addressId: last(state.paymentsManager.customer.addresses).id,
        streetAddress: last(state.paymentsManager.customer.addresses)
          .streetAddress,
        extendedAddress: last(state.paymentsManager.customer.addresses)
          .extendedAddress,
        locality: last(state.paymentsManager.customer.addresses).locality,
        region: last(state.paymentsManager.customer.addresses).region,
        postalCode: last(state.paymentsManager.customer.addresses).postalCode,
        numberOfAddresses: state.paymentsManager.customer.addresses.length,
      }
    }

    return {}
  },
  (dispatch) => bindActionCreators({ updateAddress, getCustomer }, dispatch),
)(Address)
